import { cn } from "@/lib/utils";

interface KpiCardProps {
  label: string;
  value: string;
  delta?: string;
  deltaDir?: "up" | "down" | "neutral";
  caption?: string;
  accent?: string; // hsl var p/ dotinho no topo do card
  onClick?: () => void;
}

export function KpiCard({ label, value, delta, deltaDir = "neutral", caption, accent, onClick }: KpiCardProps) {
  const chipColor =
    deltaDir === "up"
      ? "bg-success/15 text-success"
      : deltaDir === "down"
        ? "bg-danger/15 text-danger"
        : "bg-bg-card-hover text-text-muted";
  const arrow = deltaDir === "up" ? "▲" : deltaDir === "down" ? "▼" : "·";
  const interactive = !!onClick;

  return (
    <div
      role={interactive ? "button" : undefined}
      tabIndex={interactive ? 0 : undefined}
      onClick={onClick}
      onKeyDown={interactive ? (e) => (e.key === "Enter" || e.key === " ") && onClick!() : undefined}
      className={cn(
        "group relative rounded-lg border border-border-subtle bg-bg-card p-6 space-y-4 transition",
        interactive &&
          "cursor-pointer hover:-translate-y-0.5 hover:border-brand-amber hover:shadow-[0_8px_24px_-12px_rgba(245,158,11,0.35)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-amber focus-visible:ring-offset-2 focus-visible:ring-offset-bg-primary"
      )}
    >
      {interactive && (
        <span
          aria-hidden
          className="pointer-events-none absolute right-4 top-4 text-xs text-text-muted opacity-0 transition group-hover:opacity-100"
        >
          Ver lista →
        </span>
      )}
      <div className="flex items-center gap-2">
        {accent && <span className="h-2 w-2 rounded-full" style={{ backgroundColor: accent }} />}
        <span className="text-[11px] font-medium uppercase tracking-[0.1em] text-text-muted">{label}</span>
      </div>
      <div className="text-3xl font-bold tracking-tight text-text-primary">{value}</div>
      {(delta || caption) && (
        <div className="flex items-center gap-2">
          {delta && (
            <span
              className={cn(
                "inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-semibold",
                chipColor
              )}
            >
              <span>{arrow}</span>
              <span>{delta}</span>
            </span>
          )}
          {caption && <span className="text-xs text-text-muted">{caption}</span>}
        </div>
      )}
    </div>
  );
}
